import axios from '@/axios'

export default {
  state: {
    truckTypes: [],
    bodyTypes: []
  },
  actions: {
    getBodyTypes ({ commit }) {
      axios.get('/platform/types/body-types')
        .then(res => {
          commit('setBodyTypes', res.data)
        })
        .catch(err => {
          console.log(err.response)
        })
    },
    getTruckTypes ({ commit }) {
      axios.get('/platform/types/truck-types')
        .then(res => {
          commit('setTruckTypes', res.data)
        })
        .catch(err => {
          console.log(err.response)
        })
    }
  },
  mutations: {
    setBodyTypes (state, data) {
      state.bodyTypes = []
      data.forEach(element => {
        state.bodyTypes.push({ label: element.replace(/_/g, ' '), value: element })
      })
    },
    setTruckTypes (state, data) {
      state.truckTypes = []
      data.forEach(element => {
        state.truckTypes.push({ label: element.replace(/_/g, ' '), value: element })
      })
    }
  },
  getters: {
    getBodyTypes: state => {
      return state.bodyTypes
    },
    getTruckTypes: state => {
      return state.truckTypes
    }
  }
}
